export class RequestAllegatoDownload
{
    public idAllegato?: number;

    public fornitore?: string;    
}